module.exports = __webpack_public_path__ + "static/media/media3.f46d25e7.jpeg";